// @flow
import { xml2js } from 'xml-js'

const xmljsOptions = {
  compact: true,
  nativeType: true,
}

async function fetchEvents(lang: string, dates: Array<string>): any {
  let datesFmt = ''
  if (dates && dates[0].length > 0) {
    datesFmt = `${datesFmt}&start=${dates[0]}`
  }
  if (dates && dates[1].length > 0) {
    datesFmt = `${datesFmt}&end=${dates[1]}`
  }

  const baseUrl = process.env.REACT_APP_API_URL
  const url = `${baseUrl}/AppEventiV3/applisting?lang=${lang}${datesFmt}`
  console.log('Fetching: ', url)

  let response = await fetch(url)
  let text = await response.text()
  return xml2js(text, xmljsOptions)
}

async function fetchTags() {
  const baseUrl = process.env.REACT_APP_API_URL
  const url = `${baseUrl}/AppEventiV3/appeventi`
  console.log('Fetching: ', url)

  let response = await fetch(url)
  let text = await response.text()
  return xml2js(text, xmljsOptions)
}

async function fetchEventDetails(UID: string) {
  const baseUrl = process.env.REACT_APP_API_URL
  const url = `${baseUrl}/AppEventiV3/appdetail?uid=${UID}`
  console.log('Fetching: ', url)

  let response = await fetch(url)
  let text = await response.text()
  return xml2js(text, xmljsOptions)
}

export { fetchEvents, fetchTags, fetchEventDetails, xmljsOptions }
